import OtsTipline from "./OtsTipline"

OtsTipline.install = Vue => {
    vue.component(OtsTipline.name,OtsTipline)
}


export default OtsTipline